import React from 'react'
import { useTranslation } from 'react-i18next'

import { useFormState } from '../../../../../packages/kiti/components/form/form/FormHandler'
import FloatingMenu, { FloatingMenuItem } from '../../../../../packages/kiti/components/navigation/FloatingMenu'
import Line from '../../../../../packages/kiti/components/helpers/Line'
import { uniqId } from '@btime/helpers'
import { assoc, compose, dissoc, map, pathOr, pick } from 'ramda'

const useDuplicate = (field, index) => {
  const { handleChangeIn, duplicateIn } = useFormState()
  const nextIndex = index + 1

  const options = map(
    compose(
      pick(['name', 'reference', 'ordination']), //
      dissoc('id'),
      assoc('reference', uniqId())
    ),
    pathOr([], ['options'], field)
  )

  return () => {
    duplicateIn([index])

    handleChangeIn([nextIndex, 'id'], undefined)
    handleChangeIn([nextIndex, 'field_id'], undefined)
    handleChangeIn([nextIndex, 'reference'], uniqId())
    handleChangeIn([nextIndex, 'options'], options)
  }
}

const FieldMenu = ({ field, index }) => {
  const { handleChangeIn, removeIn } = useFormState()
  const isSelected = field.__selected
  const handleDuplicate = useDuplicate(field, index)
  const { t } = useTranslation('common')

  if (!isSelected) return false

  const onDelete = e => {
    e.stopPropagation()
    if (!field.id) return removeIn([index])
    handleChangeIn([index, 'deleted'], true)
  }

  return (
    <FloatingMenu>
      <FloatingMenuItem icon="BsLayers" label={t('clone')} onClick={handleDuplicate} />
      <Line />
      <FloatingMenuItem icon="BsTrash" label={t('remove')} color="red" onClick={onDelete} />
    </FloatingMenu>
  )
}

export default FieldMenu
